import EcoImg from 'eco-design/base/eco-img';
import css from './index.module.scss';
import { useLang } from '@/i18n';
import { useState } from 'react';
import gtm from '@/utils/gtm';

interface SubType {
    name: string;
    img: string;
}

interface ItemType {
    tab: string;
    subs: SubType[];
}

const Q: React.FC = () => {
    const { t } = useLang('d3u');
    const [active, setActive] = useState(0);
    const items: ItemType[] = [
        {
            tab: t('Q_item1_tab'),
            subs: [
                {
                    name: t('Q_item1_name1'),
                    img: 'https://websiteoss.ecoflow.com/upload/image/1760932579415/d3u.png',
                },
                {
                    name: t('Q_item1_name2'),
                    img: 'https://websiteoss.ecoflow.com/upload/image/1760932614080/d3u_cable.png',
                },
                {
                    name: t('Q_item1_name3'),
                    img: 'https://websiteoss.ecoflow.com/upload/image/1760932613881/d3u_ex.png',
                },
            ],
        },
        {
            tab: t('Q_item2_tab'),
            subs: [
                {
                    name: t('Q_item2_name1'),
                    img: 'https://websiteoss.ecoflow.com/upload/image/1760932996919/d3up.png',
                },
                {
                    name: t('Q_item2_name2'),
                    img: 'https://websiteoss.ecoflow.com/upload/image/1760932996499/d3up_cable.png',
                },
                {
                    name: t('Q_item2_name3'),
                    img: 'https://websiteoss.ecoflow.com/upload/image/1760932996620/d3up_ex.png',
                },
            ],
        },
    ];

    const handleChangeTab = (tx: string, k: number) => {
        if (active !== k) {
            setActive(k);
            gtm.push({
                __btn_id1: css.section,
                __btn_id2: tx,
            });
        }
    };

    return (
        <section className={`${css.section} D3U-Q GtmModuleData-section`} id="D3U-Q" data-section-id={'D3U-Q'} data-section-id2={t('Q_title')}>
            <div className="info">
                <p className="title">{t('Q_title')}</p>
            </div>
            <ul className="items">
                {items.map((item: ItemType, k: number) => (
                    <li key={k} className={`item${active === k ? ' active' : ''} GtmModuleData-btn-text`}>
                        <ul className="subs">
                            {item.subs.map((sub: SubType, m: number) => (
                                <li key={`${k}-${m}`} className="sub">
                                    <p className="name">{sub.name}</p>
                                    <div className="img">
                                        <EcoImg pc={sub.img} />
                                    </div>
                                </li>
                            ))}
                        </ul>
                    </li>
                ))}
            </ul>
            <ul className="tabs">
                {items.map((item: ItemType, k: number) => (
                    <li className={`tab${active === k ? ' active' : ''} GtmModuleData-btn-text`} key={k} onClick={() => handleChangeTab(item.tab, k)}>
                        <p className="name">{item.tab}</p>
                    </li>
                ))}
            </ul>
        </section>
    );
};

export default Q;
